import { Component, OnInit,Inject,ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup,Validators,FormArray, FormControl } from '@angular/forms';
import { ServerService } from 'src/app/services/server.service';
import { MAT_DIALOG_DATA, MatDialogRef,MatDialog } from "@angular/material";
import { ClipBoardService as messageService} from 'src/app/services/clipboard.service';

@Component({
  selector: 'app-create-marketing-job',
  templateUrl: './create-marketing-job.component.html',
  styleUrls: ['./create-marketing-job.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class CreateMarketingJobComponent implements OnInit {
  selectedPlatform = 'Meta';
  marketing_platform_type_list:any;
  marketing_job_type:any;
 
 //  links: { id: number, value: string }[] = [];
 
  marketingJobForm:FormGroup;
  authToken = localStorage.getItem('token');
  btnStatus = false;
  // this.btnStatus = true
  keywords:any=[];
  allJobData:any;
  btnValue:any;
  header:any;

  creditAllocatedInWord: any = '';

  constructor(
    private _serverService:ServerService,
    private dialogRef: MatDialogRef<CreateMarketingJobComponent>,
    private fb:FormBuilder,
    private clipBoardMessageService:messageService,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    this.allJobData = this.data;
   if(this.allJobData.previous_value != undefined){
    this.editCreativeJobForm();
    this.btnValue = "SAVE";
    this.header = "Edit Marketing Job"
   }
   else{
    this.setCreativeJobForm();
    this.btnValue = "Create Marketing Job";
    this.header = "Create Marketing Job"
   }
 
    this.getCommonDetails()
  }
  close() {
    this.dialogRef.close();
  }
  setCreativeJobForm(){
    this.marketingJobForm = this.fb.group({
      job_type:['',Validators.required],
      delivery_target: ['', Validators.required],
      budget_allocated:['',Validators.required],
      campaign_type:['',Validators.required],
      instruction:['']

    })
  }
  editCreativeJobForm(){
    this.marketingJobForm = this.fb.group({
      job_type:[this.allJobData.previous_value.job_type,Validators.required],
      delivery_target: [this.allJobData.previous_value.delivery_target, Validators.required],
      budget_allocated:[this.allJobData.previous_value.budget_allocated,Validators.required],
      campaign_type:[this.allJobData.previous_value.platform_type,Validators.required],
      instruction:[this.allJobData.previous_value.instructions]

    })
    this.selectedPlatform = this.allJobData.previous_value.platform
  }

  getCommonDetails(){
    this._serverService.getAllStatus(this.authToken).subscribe((data: any) => {
      this.marketing_job_type = data.marketing_job_type;
      this.marketing_platform_type_list = data.marketing_platform_type;
    });
  }
  platformSelection(platform:any,event?:any){
    this.selectedPlatform = platform;
  }
  create(){
    this.btnStatus = true
    let body = {
      "campaign_id": this.data.campaign_id,
      "job_type": this.marketingJobForm.value.job_type,
      "delivery_target": this.marketingJobForm.value.delivery_target,
      "budget_allocated": this.marketingJobForm.value.budget_allocated,
      "platform": this.selectedPlatform,
      "platform_type": this.marketingJobForm.value.campaign_type,
      "instructions": this.marketingJobForm.value.instruction,
    }
    if(this.allJobData.previous_value != undefined){
      this._serverService.put('campaign_module/marketing_jobs/'+ this.allJobData.previous_value.id,body,this.authToken).subscribe((data)=>{
        this.clipBoardMessageService.showMessgeInText("Marketing Job Updated Successfully", "success-snackbar")
      this.dialogRef.close(data);
       },
       error => {
        // console.error('Marketing Job Updaton failed', error);
        this.clipBoardMessageService.showMessgeInText(JSON.parse(error._body).amount, "error-snackbar")
        // console.log(JSON.parse(error._body).amount);
        this.btnStatus = false;
        // this.showComponentLoader = false;
      })
    }
    else{
      this._serverService.post('campaign_module/marketing_jobs',body,this.authToken).subscribe((data)=>{
        this.clipBoardMessageService.showMessgeInText("Marketing Job Created Successfully", "success-snackbar")
      this.dialogRef.close(data);
       },
       error => {
        // console.error('Marketing Job Creation failed', error);
        // console.log(JSON.parse(error._body).amount);
        this.clipBoardMessageService.showMessgeInText(JSON.parse(error._body).amount, "error-snackbar")
        this.btnStatus = false;
        // this.showComponentLoader = false;
      })
    }
   
  }
  onInputChange(event: any): any {

    let values = Number(event.target.value)  

    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    let minValuesWithComma:any = values;

    if ((minValuesWithComma = minValuesWithComma.toString()).length > 9) return 'overflow';

    minValuesWithComma = ('000000000' + minValuesWithComma).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

    if (!minValuesWithComma) return; var str = '';
    str += (minValuesWithComma[1] != 0) ? (a[Number(minValuesWithComma[1])] || b[minValuesWithComma[1][0]] + ' ' + a[minValuesWithComma[1][1]]) + 'crore ' : '';
    str += (minValuesWithComma[2] != 0) ? (a[Number(minValuesWithComma[2])] || b[minValuesWithComma[2][0]] + ' ' + a[minValuesWithComma[2][1]]) + 'lakh ' : '';
    str += (minValuesWithComma[3] != 0) ? (a[Number(minValuesWithComma[3])] || b[minValuesWithComma[3][0]] + ' ' + a[minValuesWithComma[3][1]]) + 'thousand ' : '';
    str += (minValuesWithComma[4] != 0) ? (a[Number(minValuesWithComma[4])] || b[minValuesWithComma[4][0]] + ' ' + a[minValuesWithComma[4][1]]) + 'hundred ' : '';
    str += (minValuesWithComma[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(minValuesWithComma[5])] || b[minValuesWithComma[5][0]] + ' ' + a[minValuesWithComma[5][1]]) + 'only ' : '';

    this.creditAllocatedInWord = str;

  }

}
